const menu = [
 {
  id: 1,
  title: 'margherita',
  category: 'pizzas',
  price: 13.99,
  img: 'https://cdn.pixabay.com/photo/2017/12/05/20/10/pizza-3000285_960_720.png',
  desc: `Paneer say cheese roquefort. Cheddar say cheese cheese and wine taleggio monterey jack everyone loves squirty cheese parmesan. `,
  favorite: false,
 },
 {
  id: 2,
  title: 'prosciutto',
  category: 'pizzas',
  price: 15.99,
  img: 'https://cdn.pixabay.com/photo/2017/12/05/20/10/pizza-3000285_960_720.png',
  desc: `Cheesecake boursin feta. Stinking bishop babybel paneer blue castello cheesecake danish fontina cauliflower cheese cheese slices. `,
  favorite: true,
 },
 {
  id: 3,
  title: 'piccante',
  category: 'pizzas',
  price: 16.99,
  img: 'https://cdn.pixabay.com/photo/2017/12/05/20/10/pizza-3000285_960_720.png',
  desc: `Camembert de normandie st. agur blue cheese cheese triangles st. agur blue cheese hard cheese croque monsieur paneer stinking bishop.`,
  favorite: false,
 },
 {
  id: 4,
  title: 'vegetariana',
  category: 'pizzas',
  price: 15.99,
  img: 'https://cdn.pixabay.com/photo/2017/12/05/20/10/pizza-3000285_960_720.png',
  desc: `Cheese on toast mozzarella dolcelatte. Red leicester babybel cottage cheese red leicester stinking bishop brie blue castello babybel.  `,
  favorite: false,
 },
 {
  id: 5,
  title: '4 formaggi',
  category: 'pizzas',
  price: 16.99,
  img: 'https://cdn.pixabay.com/photo/2017/12/05/20/10/pizza-3000285_960_720.png',
  desc: `Mascarpone cheddar camembert de normandie. Everyone loves bavarian bergkase fromage fromage boursin airedale cauliflower cheese edam.`,
  favorite: true,
 },
 {
  id: 6,
  title: '4 stagioni',
  category: 'pizzas',
  price: 14.99,
  img: 'https://cdn.pixabay.com/photo/2017/12/05/20/10/pizza-3000285_960_720.png',
  desc: `Edam roquefort hard cheese. Monterey jack macaroni cheese blue castello mozzarella when the cheese comes out everybody's happy red leicester feta goat. `,
  favorite: false,
 },
 {
  id: 7,
  title: 'Italia',
  category: 'pizzas',
  price: 18.99,
  img: 'https://cdn.pixabay.com/photo/2017/12/05/20/10/pizza-3000285_960_720.png',
  desc: `Goat manchego caerphilly. Bocconcini ricotta monterey jack edam cheese and biscuits cream cheese cream cheese roquefort.`,
  favorite: false,
 },
 {
  id: 8,
  title: 'frutti di mare',
  category: 'pizzas',
  price: 12.99,
  img: 'https://cdn.pixabay.com/photo/2017/12/05/20/10/pizza-3000285_960_720.png',
  desc: `Halloumi hard cheese cheddar. Boursin st. agur blue cheese halloumi cottage cheese brie bavarian bergkase brie cheese strings. `,
  favorite: true,
 },
 {
  id: 9,
  title: 'Regina Napoletana',
  category: 'pizzas',
  price: 16.99,
  img: 'https://cdn.pixabay.com/photo/2017/12/05/20/10/pizza-3000285_960_720.png',
  desc: `Paneer say cheese roquefort. Cheddar say cheese cheese and wine taleggio monterey jack everyone loves squirty cheese parmesan. `,
  favorite: true,
 },
 {
  id: 10,
  title: 'neapolitan di buffala',
  category: 'starters',
  price: 11.90,
  img: 'https://cdn.pixabay.com/photo/2020/06/03/08/53/mozzarella-5254110_960_720.jpg',
  desc: `Jarlsberg the big cheese chalk and cheese. Cheese and wine cut the cheese blue castello blue castello monterey jack gouda paneer mozzarella. `,
 },
 {
  id: 11,
  title: 'foccaccia barese',
  category: 'starters',
  price: 8.99,
  img: 'https://images.pexels.com/photos/95217/pexels-photo-95217.jpeg?cs=srgb&dl=pexels-markus-spiske-95217.jpg&fm=jpg',
  desc: `Parmesan parmesan queso. Gouda taleggio squirty cheese swiss cottage cheese blue castello halloumi everyone loves. `,
 },
 {
  id: 12,
  title: 'iberian burrata',
  category: 'starters',
  price: 13.99,
  img: 'https://images.pexels.com/photos/3669501/pexels-photo-3669501.jpeg?cs=srgb&dl=pexels-sebastian-coman-photography-3669501.jpg&fm=jpg',
  desc: `Stinking bishop brie everyone loves. Camembert de normandie cheesecake cream cheese pepper jack goat paneer ricotta squirty cheese. `,
 },
 {
  id: 13,
  title: 'pannacotta',
  category: 'desserts',
  price: 4.50,
  img: 'https://images.pexels.com/photos/9659666/pexels-photo-9659666.jpeg?cs=srgb&dl=pexels-simplyart-9659666.jpg&fm=jpg',
  desc: `Macaroni cheese feta stilton. Emmental babybel everyone loves cheesy feet caerphilly gouda who moved my cheese melted cheese. `,
 },
 {
  id: 14,
  title: 'chocolate cake',
  category: 'desserts',
  price: 5.50,
  img: 'https://cdn.pixabay.com/photo/2017/03/07/04/41/swede-cakes-2123192_960_720.jpg',
  desc: `Paneer say cheese roquefort. Cheddar say cheese cheese and wine taleggio monterey jack everyone loves squirty cheese parmesan. `,
 },
 {
  id: 15,
  title: 'tiramisú',
  category: 'desserts',
  price: 5.90,
  img: 'https://cdn.pixabay.com/photo/2015/09/09/19/49/dessert-932884_960_720.jpg',
  desc: `Gouda fromage frais monterey jack. Mascarpone caerphilly stinking bishop dolcelatte rubber cheese cottage cheese queso bocconcini. `,
 },
 {
  id: 16,
  title: 'peronni beer',
  category: 'drinks',
  price: 3.50,
  img: 'https://cdn.pixabay.com/photo/2014/08/10/18/06/beers-414914_960_720.jpg',
  desc: `Ricotta cauliflower cheese cheese strings. Monterey jack babybel cow ricotta manchego fondue rubber cheese fondue.`,
 },
 {
  id: 17,
  title: 'lambrusco',
  category: 'drinks',
  price: 14.90,
  img: 'https://cdn.pixabay.com/photo/2017/10/22/15/11/lambrusco-2878033_960_720.jpg',
  desc: `Cheeseburger lancashire cheddar. Emmental everyone loves blue castello danish fontina mascarpone cow the big cheese airedale.`,
 },
 {
  id: 18,
  title: 'chardonnay',
  category: 'drinks',
  price: 15.90,
  img: 'https://cdn.pixabay.com/photo/2017/09/26/16/44/wine-2789265_960_720.jpg',
  desc: `St. agur blue cheese the big cheese melted cheese. Squirty cheese jarlsberg rubber cheese fromage red leicester red leicester paneer airedale. `,
 },
];
export default menu;
